import React from 'react';
import { RewardedState } from './sdk';
import { useGameBridge } from './SDKProvider';

interface ShowRewardedCallbacks {
    onSuccess?: VoidFunction;
    onError?: VoidFunction;
    onClose?: VoidFunction;
}

export const useRewarded = () => {
    const sdk = useGameBridge();
    const rewardIssuedRef = React.useRef(false);
    const onSuccessCallbackRef = React.useRef<VoidFunction>();
    const onErrorCallbackRef = React.useRef<VoidFunction>();
    const onCloseCallbackRef = React.useRef<VoidFunction>();

    React.useEffect(() => {
        const listener = (state: RewardedState) => {
            if (!rewardIssuedRef.current) {
                return;
            }

            if (state === 'rewarded') {
                if (onSuccessCallbackRef.current) {
                    onSuccessCallbackRef.current();
                }
            } else if (state === 'failed') {
                if (onErrorCallbackRef.current) {
                    onErrorCallbackRef.current();
                }
            } else if (state === 'closed') {
                rewardIssuedRef.current = false;
                if (onCloseCallbackRef.current) {
                    onCloseCallbackRef.current();
                }
            }
        };

        sdk.advertisement.on('rewarded_state_changed', listener);

        return () => sdk.advertisement.off('rewarded_state_changed', listener);
    }, []);

    return React.useCallback((callbacks: ShowRewardedCallbacks) => {
        onSuccessCallbackRef.current = callbacks.onSuccess;
        onErrorCallbackRef.current = callbacks.onError;
        onCloseCallbackRef.current = callbacks.onClose;

        rewardIssuedRef.current = true;
        sdk.advertisement.showRewarded();
    }, []);
};
